module.exports = __webpack_public_path__ + "static/media/pioneer.f3fcc210.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/commanders/pioneer.png
// module id = 2071
// module chunks = 0